import React from 'react'
import { TdWrapper, TdTooltip } from './Td.styled'
import { CSSProperties } from 'styled-components'
import { OtherText } from 'styling/Typography'

interface TdProps {
  text?: string | number
  w?: string
  h?: string
  children?: any
  noTooltip?: boolean
  svgColor?: string
  marginLeft?: string
  toolTipText?: string
  onClick?: (e) => any
  cutText?: boolean
  tooltipLeft?: boolean
  action?: boolean
  options?: boolean
  skew?: boolean
  color?: string
}

export const Td = ({ text, w, h, children, noTooltip, svgColor, marginLeft, toolTipText, onClick, cutText, action, options, skew, color }: TdProps) => {

  let style: CSSProperties = !action ? { position: 'relative', width: w, height: h, pointerEvents: 'none', marginLeft } : { position: 'absolute', width: w, height: h, pointerEvents: 'none', right: '0', top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }
  if (options) {
    style = { ...style, alignItems: 'center', display: 'flex', justifyContent: 'end', zIndex: 999999999 }
  }
  return (
    <div onClick={onClick} style={style}>
      <TdWrapper style={h ? { height: h } : {}} cutText={cutText} noTooltip={(!text || noTooltip) && !toolTipText} svgColor={svgColor} skew={skew} >
        {children || <OtherText style={{ height: 'max-content' }} color={color} >{text}</OtherText>}
        {/* {(text || toolTipText) && <TdTooltip left={tooltipLeft} className='tooltip' >{text || toolTipText}</TdTooltip>} */}
      </TdWrapper>
    </div>
  )
}
